import { FC, ReactNode } from 'react'
import { PerkAvatar, PerkAvatarType } from './Avatar'
import { PerkCard, PerkCardType } from './Card'

const Perk: FC & PerkAvatarType & PerkCardType = (): ReactNode => <></>

Perk.Avatar = PerkAvatar
Perk.Card = PerkCard

export default Perk
